<template>
  <div class="submit-reminder">
    <div class="buttons-container">
      <BackstageButton
        :variant="ButtonVariant.SECONDARY"
        :icon-right="isDeleting"
        :disabled="!deleteDraftEnabled"
        v-on:click="deleteDraft">
        {{ $t('global.submit_reminder_popup.delete_button') }}
      </BackstageButton>
      <BackstageButton
        :variant="ButtonVariant.SECONDARY"
        :icon-right="isSaving"
        :disabled="!saveDraftEnabled"
        v-on:click="save">
        {{ $t('global.submit_reminder_popup.save_for_later_button') }}
      </BackstageButton>
      <BackstageButton :icon-right="isSubmitting" :disabled="!submitEnabled" v-on:click="submitDraft">
        {{ $t('global.submit_reminder_popup.submit_button') }}
      </BackstageButton>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackstageButton from './BackstageButton.vue';
import { ButtonVariant } from '@/models/button-variant.enum';

export default defineComponent({
  name: 'submit-reminder',
  components: {
    BackstageButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    saveDraftEnabled: {
      type: Boolean,
      default: true,
    },
    deleteDraftEnabled: {
      type: Boolean,
      default: true,
    },
    submitEnabled: {
      type: Boolean,
      default: true,
    },
    deleting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ButtonVariant,
    };
  },
  computed: {
    isDeleting(): 'loading' | undefined {
      return this.deleting ? 'loading' : undefined;
    },
    isSaving(): 'loading' | undefined {
      return this.saving ? 'loading' : undefined;
    },
    isSubmitting(): 'loading' | undefined {
      return this.submitting ? 'loading' : undefined;
    },
  },
  methods: {
    save() {
      this.$emit('save');
    },
    submitDraft() {
      if (this.submitEnabled) {
        this.$emit('submit');
      }
    },
    deleteDraft() {
      this.$emit('delete');
    },
  },
});
</script>

<style scoped lang="scss">
.submit-reminder {
  display: flex;
  justify-content: center;

  .buttons-container {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 5px;
  }
}
</style>
